import { useDropzone } from 'react-dropzone'
import { memo, useEffect, useRef } from 'react'
import css from './pngDropzone.module.css'
import { ReactComponent as CancelIcon } from '../../../asserts/icons/xmark.svg'
import { IImage } from '../../../types/tasks.types'

interface IProps {
  image?: IImage
  onFile: (file: File) => void
  placeHolder?: string
}

const Dropzone = (props: IProps) => {
  const firstRender = useRef(true)
  const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
    maxFiles: 1,
    accept: { 'image/png': ['.png'] },
  })

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }

    props.onFile(acceptedFiles[0])
  }, [acceptedFiles])

  let imageUrl = props.image?.file
  // @ts-ignore
  if (props.image?.imageFile instanceof File) imageUrl = URL.createObjectURL(props.image.imageFile)
  else if (!imageUrl && acceptedFiles[0]) imageUrl = URL.createObjectURL(acceptedFiles[0])

  if (imageUrl) {
    return (
      <div className={css.dropzone} style={{ cursor: 'auto' }} data-uploaded={true}>
        <div className={css.imagePreview} style={{ backgroundImage: `url(${imageUrl})` }} />
        <CancelIcon className={css.cancel} fill="var(--gray)" onClick={open} />
      </div>
    )
  }

  return (
    <div {...getRootProps({ className: css.dropzone })} data-uploaded={false}>
      <p>{props.placeHolder || 'Кликните или перетащите сюда изображение'}</p>
      <input {...getInputProps()} />
    </div>
  )
}

export default memo(Dropzone)
